import { FormContainer, IFormMessageProps } from '../../../_core/form/form-container.component';
import { CreateBlankTemplateForm, ICreateBlankTemplateFormValues } from './create-blank-template-form.component';

export interface ICreateBlankTemplateContainerProps extends IFormMessageProps {
  onSubmit: (_: ICreateBlankTemplateFormValues) => Promise<void>;
}

export const CreateBlankTemplateNestedContainer = ({ onSubmit, ...rest }: ICreateBlankTemplateContainerProps) => {
  return (
    <FormContainer {...rest} title="Create Template">
      <CreateBlankTemplateForm onSubmit={onSubmit} />
    </FormContainer>
  );
};
